<template>
  <div>
    <div class="panel panel-primary">
      <div
        class="panel-heading"
        @click="formInfoEmpresa.showForm = !formInfoEmpresa.showForm"
      >
        4.1 - INFORMAÇÕES DA EMPRESA
        <span class="pull-right">
          <i
            style="font-size: 1.5em"
            :class="
              formInfoEmpresa.showForm
                ? 'fa fa-arrow-down'
                : 'fa fa-arrow-right'
            "
            aria-hidden="true"
          ></i>
        </span>
      </div>
      <div v-if="formInfoEmpresa.showForm" class="panel-body">
        <div class="row">
          <div class="col-md-6">
            <form-helper
              :inputVar="formInfoEmpresa.razaoSocial"
              :form="formInfoEmpresa"
              label="Razão Social"
              placeholder="Digite"
              :disabled="true"
            />
          </div>
          <div class="col-md-6">
            <form-helper
              :inputVar="formInfoEmpresa.faturamentoMensal"
              :form="formInfoEmpresa"
              type="money"
              label="Faturamento Mensal"
              placeholder="Digite"
              :disabled="true"
            />
          </div>
          <div class="col-md-6">
            <form-helper
              :inputVar="formInfoEmpresa.email"
              :form="formInfoEmpresa"
              validationType="email"
              label="Email"
              type="email"
              id="email1"
              placeholder="Digite"
              :disabled="formInfoEmpresa.disableEmail"
            />
          </div>
          <div class="col-md-6">
            <form-helper
              :inputVar="formInfoEmpresa.telefone"
              :form="formInfoEmpresa"
              label="Telefone Celular"
              id="TelefoneCelular"
              placeholder="(##) #####-####"
              :mask="'(##) #####-####'"
              :disabled="formInfoEmpresa.disableTelefone"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="panel panel-primary">
      <div
        class="panel-heading"
        @click="formInfoInstalacao.showForm = !formInfoInstalacao.showForm"
      >
        4.2 - ENDEREÇO DE INSTALAÇÃO
        <span class="pull-right">
          <i
            style="font-size: 1.5em"
            :class="
              formInfoInstalacao.showForm
                ? 'fa fa-arrow-down'
                : 'fa fa-arrow-right'
            "
            aria-hidden="true"
          ></i>
        </span>
      </div>
      <div v-if="formInfoInstalacao.showForm" class="panel-body">
        <div class="row">
          <div class="col-md-3">
            <form-helper
              :inputVar="formInfoInstalacao.cep"
              :form="formInfoEmpresa"
              label="CEP"
              id="CEP"
              placeholder="Digite"
              :mask="'#####-###'"
              :disabled="formInfoInstalacao.disableCep"
            />
          </div>
          <div class="col-md-9">
            <form-helper
              :inputVar="formInfoInstalacao.endereco"
              :form="formInfoEmpresa"
              label="Endereço"
              id="Endereco"
              placeholder="Digite"
              :disabled="formInfoInstalacao.disableEndereco"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-md-3">
            <form-helper
              :inputVar="formInfoInstalacao.numero"
              :form="formInfoEmpresa"
              type="number"
              :min="0"
              label="Número"
              placeholder="Digite"
            />
          </div>
          <div class="col-md-3">
            <form-helper
              :inputVar="formInfoInstalacao.complemento"
              :form="formInfoEmpresa"
              label="Complemento"
              id="Complemento1"
              placeholder="Digite"
            />
          </div>
          <div class="col-md-6">
            <form-helper
              :inputVar="formInfoInstalacao.bairro"
              :form="formInfoEmpresa"
              label="Bairro"
              id="Bairro"
              placeholder="Digite"
              :disabled="formInfoInstalacao.disableBairro"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-md-3">
            <form-helper
              :inputVar="formInfoInstalacao.estado"
              :form="formInfoEmpresa"
              label="Estado"
              placeholder="Digite"
              :disabled="true"
            />
          </div>
          <div class="col-md-3">
            <form-helper
              :inputVar="formInfoInstalacao.cidade"
              :form="formInfoEmpresa"
              label="Cidade"
              placeholder="Digite"
              :disabled="true"
            />
          </div>
          <div class="col-md-6">
            <div class="choose-checkbox-methods">
              <label class="checkbox-option" style="margin-top: 30px">
                <input
                  name="aceitoTerms"
                  value="1"
                  type="checkbox"
                  checked
                  v-model="formInfoInstalacao.mesmoEndereco"
                  :disabled="
                    formInfoInstalacao.disableMesmoEndereco || currentStep > 4
                  "
                />
                <span>
                  Endereço de cobrança é o mesmo endereço de instalação
                </span>
              </label>
            </div>
          </div>
        </div>
        <div class="row" v-if="formInfoInstalacao.mesmoEndereco">
          <div class="col-md-12">
            <button
              v-if="currentStep == 4"
              aria-label="Anterior"
              style="float: left; margin-right: 1em"
              class="btn btn-primary"
              @click="previousStep()"
            >
              <i class="fa fa-chevron-left"></i> Anterior
            </button>

            <button
              v-if="!loading && currentStep == 4"
              aria-label="Próximo"
              style="float: left; margin-right: 1em"
              class="btn btn-primary"
              @click="sendProposta()"
            >
              Enviar Proposta <i class="fa fa-chevron-right"></i>
            </button>

            <Loader
              v-if="loading"
              style="margin-top: -5px; margin-left: 20px"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="panel panel-primary" v-if="!formInfoInstalacao.mesmoEndereco">
      <div
        class="panel-heading"
        @click="formInfoCobranca.showForm = !formInfoCobranca.showForm"
      >
        4.3 - ENDEREÇO DE COBRANÇA
        <span class="pull-right">
          <i
            style="font-size: 1.5em"
            :class="
              formInfoCobranca.showForm
                ? 'fa fa-arrow-down'
                : 'fa fa-arrow-right'
            "
            aria-hidden="true"
          ></i>
        </span>
      </div>
      <div v-if="formInfoCobranca.showForm" class="panel-body">
        <div class="row">
          <div class="col-md-3">
            <form-helper
              :inputVar="formInfoCobranca.cep"
              :form="formInfoCobranca"
              :mask="'#####-###'"
              label="CEP"
              placeholder="Digite"
              :disabled="formInfoCobranca.disableCep || currentStep > 4"
            />
          </div>
          <div class="col-md-9">
            <form-helper
              :inputVar="formInfoCobranca.endereco"
              :form="formInfoCobranca"
              label="Endereço"
              placeholder="Digite"
              :disabled="formInfoCobranca.disableEndereco"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-md-3">
            <form-helper
              :inputVar="formInfoCobranca.numero"
              :form="formInfoCobranca"
              label="Número"
              placeholder="Digite"
            />
          </div>
          <div class="col-md-3">
            <form-helper
              :inputVar="formInfoCobranca.complemento"
              :form="formInfoCobranca"
              label="Complemento"
              placeholder="Digite"
            />
          </div>
          <div class="col-md-6">
            <form-helper
              :inputVar="formInfoCobranca.bairro"
              :form="formInfoCobranca"
              label="Bairro"
              placeholder="Digite"
              :disabled="formInfoCobranca.disableBairro"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-md-3">
            <form-helper
              :inputVar="formInfoCobranca.estado"
              :form="formInfoCobranca"
              label="Estado"
              placeholder="Digite"
            />
          </div>
          <div class="col-md-3">
            <form-helper
              :inputVar="formInfoCobranca.cidade"
              :form="formInfoCobranca"
              label="Cidade"
              placeholder="Digite"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <button
              v-if="currentStep == 4"
              aria-label="Anterior"
              style="float: left; margin-right: 1em"
              class="btn btn-primary"
              @click="previousStep()"
            >
              <i class="fa fa-chevron-left"></i> Anterior
            </button>

            <button
              v-if="!loading && currentStep == 4"
              aria-label="Próximo"
              style="float: left; margin-right: 1em"
              class="btn btn-primary"
              @click="sendProposta()"
            >
              Enviar Proposta <i class="fa fa-chevron-right"></i>
            </button>

            <Loader
              v-if="loading"
              style="margin-top: -5px; margin-left: 20px"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FormHelper from "@/components/partials/FormHelper.vue";
import Endereco from "@/services/Endereco";
import SolAgoraService from "@/services/SolAgoraService";

const respostaPadraoErroGenerico =
  "Serviço indisponível, tente novamente mais tarde.";

export default {
  name: "SolAgoraJuridico",

  props: {
    total: { type: Number, default: 0 },
    cliente: { type: Object, default: null },
    cepCobranca: { type: String, default: "" },
    codigoPedido: { type: String, default: 0 },
    resultadoSimulacao: { type: Object, default: null },
    currentStep: { type: Number, default: 0 },
    idProject: { type: String, default: "" },
    token: { type: String, default: null },
  },

  components: {
    FormHelper,
  },

  data() {
    return {
      formInfoEmpresa: {
        showForm: true,
        razaoSocial: new this.$formInput(true),
        faturamentoMensal: new this.$formInput(true),
        email: new this.$formInput(true),
        disableEmail: true,
        telefone: new this.$formInput(true),
        disableTelefone: true,
        attemptSubmit: false,
      },
      formInfoInstalacao: {
        showForm: true,
        cep: new this.$formInput(true),
        endereco: new this.$formInput(true),
        numero: new this.$formInput(true),
        complemento: new this.$formInput(false),
        bairro: new this.$formInput(true),
        estado: new this.$formInput(true),
        cidade: new this.$formInput(true),
        disableCep: false,
        disableEndereco: true,
        disableBairro: true,
        disableNumero: true,
        disableComplemento: true,
        mesmoEndereco: true,
        disableMesmoEndereco: false,
        attemptSubmit: false,
      },
      formInfoCobranca: {
        showForm: true,
        cep: new this.$formInput(true),
        endereco: new this.$formInput(true),
        numero: new this.$formInput(true),
        complemento: new this.$formInput(false),
        bairro: new this.$formInput(true),
        estado: new this.$formInput(true),
        cidade: new this.$formInput(true),
        disableCep: false,
        disableEndereco: false,
        disableBairro: false,
        attemptSubmit: false,
      },
      isLoaded: false,
      loading: false,
    };
  },
  async mounted() {
    this.load();
  },
  methods: {
    load: async function () {
      if (!this.isLoaded) {
        this.setDadosEmpresa();
        await this.setEnderecoInstalacao();

        this.isLoaded = true;
      }
    },

    setDadosEmpresa() {
      this.formInfoEmpresa.razaoSocial.value = this.cliente.CLI_RAZAOSOCIAL;
      this.formInfoEmpresa.faturamentoMensal.value =
        this.resultadoSimulacao.monthlyIncome;
      this.formInfoEmpresa.email.value = this.cliente.CLI_EMAIL;
      this.formInfoEmpresa.disableEmail = this.cliente.CLI_EMAIL !== "";
      this.formInfoEmpresa.telefone.value = this.cliente.CLI_FONE;
      this.formInfoEmpresa.disableTelefone = this.cliente.CLI_FONE !== "";
    },

    async setEnderecoInstalacao() {
      this.formInfoInstalacao.disableCep = this.cliente.CLI_CEP !== "";
      this.formInfoInstalacao.cep.value = this.cliente.CLI_CEP;

      this.formInfoInstalacao.disableEndereco =
        this.cliente.CLI_ENDERECO !== "";
      this.formInfoInstalacao.endereco.value = this.cliente.CLI_ENDERECO;

      this.formInfoInstalacao.numero.value = this.cliente.CLI_NUMEROENDERECO;
      this.formInfoInstalacao.disableNumero =
        this.cliente.CLI_NUMEROENDERECO !== "";

      this.formInfoInstalacao.complemento.value =
        this.cliente.CLI_COMPLEMENTOENDERECO;
      this.formInfoInstalacao.disableComplemento =
        this.cliente.CLI_COMPLEMENTOENDERECO !== "";

      this.formInfoInstalacao.disableBairro = this.cliente.CLI_BAIRRO !== "";
      this.formInfoInstalacao.bairro.value = this.cliente.CLI_BAIRRO;

      this.formInfoInstalacao.estado.value = this.cliente.EST_UF;
      this.formInfoInstalacao.cidade.value = this.cliente.CLI_CIDADE;

      this.formInfoInstalacao.mesmoEndereco =
        this.cliente.CLI_CEP.replace("-", "") ===
        this.cepCobranca.replace("-", "");

      if (!this.formInfoInstalacao.mesmoEndereco) {
        this.formInfoCobranca.cep.value = this.cepCobranca;
      }
      this.formInfoInstalacao.disableMesmoEndereco = true;
    },

    previousStep: function () {
      this.$emit("previous");
    },

    async sendProposta() {
      try {
        this.loading = true;

        this.formInfoEmpresa.attemptSubmit = true;
        this.formInfoInstalacao.attemptSubmit = true;
        this.formInfoCobranca.attemptSubmit =
          !this.formInfoInstalacao.mesmoEndereco;
        let totalErrors = this.formErrors;

        if (totalErrors) {
          swal({
            title: "Preencha os campos obrigatórios",
            text: "Números de campos a serem preenchidos: " + totalErrors,
            icon: "warning",
          });

          return;
        }

        const pev_codigo = this.codigoPedido.toString().split("-")[0];
        const res = await SolAgoraService.SendProposal({
          apiUrl: this.$apiUrl,
          token: this.token,
          idProject: this.idProject,
          resultadoSimulacao: this.resultadoSimulacao,
          installationAddress: {
            cep: this.formInfoInstalacao.cep.value,
            streetAddress: this.formInfoInstalacao.endereco.value,
            state: this.formInfoInstalacao.estado.value,
            neighborhood: this.formInfoInstalacao.bairro.value,
            city: this.formInfoInstalacao.cidade.value,
            number: this.formInfoInstalacao.numero.value,
            complement: this.formInfoInstalacao.complemento.value,
          },
          address: {
            cep: this.formInfoInstalacao.mesmoEndereco
              ? this.formInfoInstalacao.cep.value
              : this.formInfoCobranca.cep.value,
            streetAddress: this.formInfoInstalacao.mesmoEndereco
              ? this.formInfoInstalacao.endereco.value
              : this.formInfoCobranca.endereco.value,
            state: this.formInfoInstalacao.mesmoEndereco
              ? this.formInfoInstalacao.estado.value
              : this.formInfoCobranca.estado.value,
            neighborhood: this.formInfoInstalacao.mesmoEndereco
              ? this.formInfoInstalacao.bairro.value
              : this.formInfoCobranca.bairro.value,
            city: this.formInfoInstalacao.mesmoEndereco
              ? this.formInfoInstalacao.cidade.value
              : this.formInfoCobranca.cidade.value,
            number: this.formInfoInstalacao.mesmoEndereco
              ? this.formInfoInstalacao.numero.value
              : this.formInfoCobranca.numero.value,
            complement: this.formInfoInstalacao.mesmoEndereco
              ? this.formInfoInstalacao.complemento.value
              : this.formInfoCobranca.complemento.value,
          },
          hardwareCost: this.total,
          laborCost: this.resultadoSimulacao.laborCost,
          power: 1,
          codigoPedido: pev_codigo,
        });

        if (!res) {
          swal({
            title: "Aviso",
            text: respostaPadraoErroGenerico,
            icon: "warning",
          });
          return;
        }

        if (res.message) {
          swal({
            title: "Aviso",
            text: res.message,
            icon: "warning",
          });
          return;
        }

        if (!res.data.Success) {
          swal({
            title: "Proposta Negada",
            text: res.data.Message,
            icon: "warning",
          });
          return;
        }

        swal({
          title: "Proposta registrada com sucesso!",
          icon: "success",
        });

        this.$emit("setResultadoProposta", res.data);
        this.$emit("next");
      } finally {
        this.loading = false;
      }
    },
  },

  watch: {
    "formInfoInstalacao.cep.value": async function (val) {
      if (val.length !== 9 || this.formInfoInstalacao.disableCep) return;

      const address = await Endereco.buscaCEP(val);

      if (!address) {
        swal({
          title: "Aviso",
          text: "O CEP informado não é válido.",
          icon: "warning",
        });

        return;
      }

      this.formInfoInstalacao.disableEndereco = address.logradouro !== "";
      this.formInfoInstalacao.endereco.value = address.logradouro;
      this.formInfoInstalacao.disableBairro = address.bairro !== "";
      this.formInfoInstalacao.bairro.value = address.bairro;
      this.formInfoInstalacao.estado.value = address.uf;
      this.formInfoInstalacao.cidade.value = address.localidade;
    },

    "formInfoCobranca.cep.value": async function (val) {
      if (val.length !== 9) return;

      const address = await Endereco.buscaCEP(val);

      if (!address) {
        swal({
          title: "Aviso",
          text: "O CEP informado não é válido.",
          icon: "warning",
        });

        return;
      }

      this.formInfoCobranca.disableEndereco = address.logradouro !== "";
      this.formInfoCobranca.endereco.value = address.logradouro;
      this.formInfoCobranca.disableBairro = address.bairro !== "";
      this.formInfoCobranca.bairro.value = address.bairro;
      this.formInfoCobranca.estado.value = address.uf;
      this.formInfoCobranca.cidade.value = address.localidade;
    },
  },

  computed: {
    formErrors: function () {
      let totalErrors = 0;

      let errors = Object.keys(this.formInfoEmpresa).filter(
        (key) =>
          this.formInfoEmpresa[key].validation &&
          !this.formInfoEmpresa[key].validation.status
      );
      totalErrors += errors.length;

      errors = Object.keys(this.formInfoInstalacao).filter(
        (key) =>
          this.formInfoInstalacao[key].validation &&
          !this.formInfoInstalacao[key].validation.status
      );
      totalErrors += errors.length;

      if (!this.formInfoInstalacao.mesmoEndereco) {
        errors = Object.keys(this.formInfoCobranca).filter(
          (key) =>
            this.formInfoCobranca[key].validation &&
            !this.formInfoCobranca[key].validation.status
        );
        totalErrors += errors.length;
      }

      return totalErrors;
    },
  },
};
</script>